const element = document.getElementById('config')
const config = element ? JSON.parse(element.innerText) : {}

export default {
  ...config
}
